import { SearchType } from '@mews-commander/enums';
import { AccountType } from '@mews-commander/data-access';
import { FieldsContainer } from '@mews-commander/ui';
import { SearchFormField } from '../../../components/form';
import { OTHER_ACCOUNT_ID_FIELD_NAME } from '../constants';
import { AccountMergeFormProps } from './AccountMergeForm';

const accountTypeToSearchTypeMap = {
    [AccountType.Company]: SearchType.Company,
    [AccountType.Customer]: SearchType.Customer,
};

export const AccountMergeFormFields = ({ accountId, form, accountType }: AccountMergeFormProps) => (
    <FieldsContainer>
        <SearchFormField
            scope={form}
            searchScope={`${form}-other-account-search`}
            except={[accountId]}
            name={OTHER_ACCOUNT_ID_FIELD_NAME}
            searchType={accountTypeToSearchTypeMap[accountType]}
        />
    </FieldsContainer>
);
